export default {
  "Cut Audio": "Cut Audio",
  "HitPaw Online Audio Cutter": "HitPaw Online Audio Cutter",
  "Trim or cut any audio files online.": "Trim or cut any audio files online.",
  "Cut": "Cut",
  "Fade in": "Fade in",
  "Fade out": "Fade out",
  "Cut from": "Cut from",
  "to": "to",
  "Extract selection": "Extract selection",
  "Delete selection": "Delete selection",
  "Adjust New": "Adjust New",
  "Cut New": "Cut New",
  "Adjust Volume": "Adjust Volume",
  "HitPaw Online Volume Changer": "HitPaw Online Volume Changer",
  "Turn up or Turn down the volume of audio.": "Turn up or Turn down the volume of audio.",
  "Volume": "Volume",
  "Change Speed": "Change Speed",
  "HitPaw Online Audio Speed Changer": "HitPaw Online Audio Speed Changer",
  "Speed up or slow down audios online easily.": "Speed up or slow down audios online easily.",
  "Speed": "Speed",
  "Format": "Format",
  "Size": "Size",
  "Duration": "Duration",
};
